import { PROCESS_ENGINEER, PROCESSER } from "app/utils/config"
import { include, isEqual } from "app/utils/javascript"

export const getJobType = ({ jobType }) => {
    switch (jobType) {
        case "FILL":
            return ({ jobType: "fill", selectedJobType: "FILL", viewJobType: "fill" })
        case "RECOVERY":
            return ({ jobType: "recover", selectedJobType: "RECOVERY", viewJobType: "recover" })
        case "PROCESS":
            return ({ jobType: "process", selectedJobType: "PROCESS", viewJobType: "process" })
        case "RECYCLE":
        case "RECYCLE_ANALYSIS":
            return ({ jobType: "recycle", selectedJobType: "RECYCLE", viewJobType: "processRecycle" })
        case "DISPOSE":
            return ({ jobType: "dispose", selectedJobType: "DISPOSE", viewJobType: "processDispose" })
        case "RENT":
            return ({ jobType: "rent", selectedJobType: "RENT", viewJobType: "rental" })
        case "TRANSFER":
            return ({ jobType: "transfer", selectedJobType: "TRANSFER", viewJobType: "transfer" })
        case "POST_RECYCLE_REFRIGERANT_TRANSFER":
            return ({ jobType: "postRecycleTransfer", selectedJobType: "POST_RECYCLE_REFRIGERANT_TRANSFER", viewJobType: "postRecycleRefrigerantTransfer" })
            // PPRT flow
        // case "RECYCLE_ANALYSIS":
        //     return ({ jobType: "recycleAnalysis", selectedJobType: "RECYCLE_ANALYSIS", viewJobType: "recycleAnalysisStage1" })
        // case "RECYCLE_ANALYSIS_STAGE_TWO":
        //     return ({ jobType: "recycleAnalysis2", selectedJobType: "RECYCLE_ANALYSIS", viewJobType: "recycleAnalysisStage2" })
        default:
            return ({ jobType: "fill", selectedJobType: "FILL", viewJobType: "fill" })
    }
}

export const completedJobsList = ["RENTAL_ARRANGE COMPLETE", "RENTAL_RETURN COMPLETE", "SE_RENTAL_RETURN COMPLETE", "FILL COMPLETED", "FILL_RECOVERY COMPLETED", "RECOVERY_FILL COMPLETED", "RECOVERY COMPLETED", "RECYCLE_COMPLETE", "RECYCLE_ANALYSIS_COMPLETE", "DISPOSE_COMPLETED", "DISPOSE_COMPLETE", "PROCESS_COMPLETED", "POST_RECYCLE_REFRIGERANT_TRANSFER_COMPLETE", "RECYCLE_ANALYSIS_STAGE_TWO_COMPLETE"]

//get editable flag for jobs (Verify all condition properly)
export const editableJob = ({ data, roleId, userData, selectedRecycleFactoryData }) => {
    const jobType = data?.jobType;
    switch (jobType) {
        case "FILL":
            return 0
        case "RECOVERY":
            return 0
        case "PROCESS":
            return (([8, 13].includes(roleId) && data?.status !== "JOB_REQUEST_INPROGRESS") || ([7, 6, 11, 16].includes(roleId) && !Object.keys(data).length) ||
                ([7, 6, 11, 16].includes(roleId) && data?.status === "JOB_REQUEST_INPROGRESS")) ? false : true
        case "RECYCLE":
            return (
                ([8, 13].includes(roleId) && Object.keys(data).length === 0 || data?.status === "JOB_REQUEST_INPROGRESS") || ([8, 13].includes(roleId) && Object.keys(data).length && data?.recycleFactoryInfo?.id === userData?.id && data?.recycleFactoryId === data?.registrantId) || /* ([8, 13].includes(roleId) && Object.keys(data).length) || */
                ([8, 13].includes(roleId) && ["RECYCLE_AWAITING RECEPTION", "RECYCLE_REQUESTED", "RECYCLE_AWAITING PROCESSING"].includes(data?.status) && (data?.recycleFactoryInfo?.id === userData?.id || ([13]?.includes(roleId) && selectedRecycleFactoryData?.id === userData?.adminId)))) ? false : true
        case "DISPOSE":
            return (([8, 13].includes(roleId) && Object.keys(data).length && (data?.status === "JOB_REQUEST_INPROGRESS" || [userData?.id, userData?.adminId].includes(selectedRecycleFactoryData?.id)))
                || Object.keys(data).length === 0) ? false : true
        case "RENT":
            return 0
        case "POST_RECYCLE_REFRIGERANT_TRANSFER":
            return 0
        case "RECYCLE_ANALYSIS":
            return 0
        case "RECYCLE_ANALYSIS_STAGE_TWO":
            return 0
        default:
            break;
    }
}

export const getTransferNextFlag = ({ selectedJob, roleId, userData }) => {
    switch (selectedJob?.status) {
        case "TRANSFER_ARRANGE_REQUESTED":
            if (include([6, 7, 11, 16], roleId)) {
                return (isEqual(7, roleId) && isEqual(userData?.id, selectedJob?.lenderInfo?.id)) ||
                    (isEqual(11, roleId) && isEqual(userData?.parent?.id, selectedJob?.lenderInfo?.id)) ||
                    (isEqual(6, roleId) && isEqual(userData?.id, selectedJob?.lenderInfo?.adminId)) ||
                    (isEqual(16, roleId) && isEqual(userData?.parent?.id, selectedJob?.lenderInfo?.adminId)) ? false : true
            } else if (include([PROCESSER, PROCESS_ENGINEER], roleId)) {
                return (isEqual(PROCESSER, roleId) && isEqual(userData?.id, selectedJob?.borrowerInfo?.id)) ||
                (isEqual(PROCESS_ENGINEER, roleId) && isEqual(userData?.parent?.id, selectedJob?.borrowerInfo?.id))
            }
            break;
        case "TRANSFER_ARRANGE INTRANSIT":
        case "TRANSFER_GIVEOUT_INTRANSIT":
            if (include([6, 7, 11, 16], roleId)) {
                return (isEqual(7, roleId) && isEqual(userData?.id, selectedJob?.borrowerInfo?.id)) ||
                    (isEqual(11, roleId) && isEqual(userData?.parent?.id, selectedJob?.borrowerInfo?.id)) ||
                    (isEqual(6, roleId) && isEqual(userData?.id, selectedJob?.borrowerInfo?.adminId)) ||
                    (isEqual(16, roleId) && isEqual(userData?.parent?.id, selectedJob?.borrowerInfo?.adminId)) ? false : true
            } else if (include([PROCESSER, PROCESS_ENGINEER], roleId)) {
                return (isEqual(PROCESSER, roleId) && isEqual(userData?.id, selectedJob?.lenderInfo?.id)) ||
                (isEqual(PROCESS_ENGINEER, roleId) && isEqual(userData?.parent?.id, selectedJob?.lenderInfo?.id))
            }
            break;
        default:
            return false
    }
}

export const getKeyName = ({ name, jobType = null }) => {
    switch (name) {
        case "refrigerantAmount":
            return { keyName: include(["DISPOSE", "RECYCLE"], jobType) ? 'refrigerantVolumeProcess' : 'refrigerantVolume' }
        case "currentWeight":
            return { keyName: 'currentWeight' }
        case "previousWeight":
            return { keyName: 'previousWeight' }

        default:
            break;
    }
}